import { Checkbox } from '@/components/ui/checkbox';

interface FilterGroupProps {
  label: string;
  options: string[];
  selected: string[];
  onChange: (next: string[]) => void;
}

export function FilterGroup({ label, options, selected, onChange }: FilterGroupProps) {
  const toggle = (value: string) => {
    onChange(selected.includes(value) ? selected.filter((v) => v !== value) : [...selected, value]);
  };
  return (
    <div>
      <p className="mb-1.5 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        {label}
      </p>
      <div className="space-y-1.5">
        {options.map((opt) => (
          // eslint-disable-next-line jsx-a11y/label-has-associated-control
          <label
            key={opt}
            className="flex min-h-11 cursor-pointer items-center gap-2.5 rounded-md text-sm hover:bg-muted/50 sm:min-h-0"
          >
            <Checkbox checked={selected.includes(opt)} onChange={() => toggle(opt)} />
            {opt}
          </label>
        ))}
      </div>
    </div>
  );
}
